import React, { useEffect } from 'react';
import { bbtNative } from '@bbtfe/webview-bridge';
import { Share } from '@components/Share';
import { isInMiniProgram, isInWechat } from '@utils/development';
import { getJsConfig } from '@utils/services';
import { lazyWeixinJsSdk } from '@utils/lazylib';
import { setupWechatShare } from '@utils/share';

export function Layout({ title, children }) {
  useEffect(() => {
    if (isInWechat())
      getJsConfig({ app_id: 'bbt_shop', url: location.href }).then(res => {
        lazyWeixinJsSdk()
          .then(wx => {
            if (!wx) {
              console.error('微信JSSDK加载失败');
              return;
            }
            const data = {
              debugger: true,
              appId: res?.appId,
              timestamp: res?.timestamp,
              nonceStr: res?.noncestr,
              signature: res?.signature,
              jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData'
              ]
            };
            wx.config(data);

            setupWechatShare({
              title: title
            });
          })
          .catch(err => {
            console.error('加载微信JSSDK失败:', err);
          });
      });
  }, []);

  return (
    <div>
      {!bbtNative.isApp() && !isInMiniProgram() && <Share />}
      {children}
    </div>
  );
}
